import RequestAbstract from "../abstract";

export default class PublicProxyLists extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-proxy-lists";
    }

}
